<div class="analysis-summary" data-cy="analysis-summary">
  <section class="analysis-summary__pending" data-cy="analysis-summary-pending">
    <h2 class="analysis-summary__pending-label">Pendentes de análise</h2>

    <p class="analysis-summary__pending-value">
      <strong>{{ metrics.pending }}</strong>
      <span>de {{ metrics.submitted }} documentos enviados</span>
    </p>

    <div class="analysis-summary__progress" role="presentation">
      <span class="analysis-summary__progress-part is-pending" [style.width]="pendingWidth"></span>
      <span
        class="analysis-summary__progress-part is-approved"
        [style.width]="approvedWidth"></span>
      <span
        class="analysis-summary__progress-part is-rejected"
        [style.width]="rejectedWidth"></span>
    </div>

    <p class="analysis-summary__pending-footnote">
      {{ metrics.analyzed }} de {{ metrics.submitted }} já analisados
    </p>
  </section>

  <section class="analysis-summary__kpis">
    <article class="analysis-summary__kpi is-total" data-cy="analysis-kpi-total">
      <h3>Total enviados</h3>
      <strong>{{ metrics.submitted }}</strong>
      <small>pendentes + aprovados + rejeitados</small>
    </article>

    <article class="analysis-summary__kpi is-approved" data-cy="analysis-kpi-approved">
      <h3>Aprovados</h3>
      <strong>{{ metrics.approved }}</strong>
      <small>{{ metrics.approvedPercent }}% do total</small>
    </article>

    <article class="analysis-summary__kpi is-rejected" data-cy="analysis-kpi-rejected">
      <h3>Rejeitados</h3>
      <strong>{{ metrics.rejected }}</strong>
      <small>{{ metrics.rejectedPercent }}% do total</small>
    </article>
  </section>
</div>
